'use client';

import { memo } from 'react';

interface Particle {
  id: number;
  x: number;
  y: number;
  delay: number;
}

interface BackgroundParticlesProps {
  particles: Particle[];
}

// Memoized component - will NEVER re-render unless particles array changes
// This completely isolates background animations from word highlighting updates
const BackgroundParticles = memo(function BackgroundParticles({ particles }: BackgroundParticlesProps) {
  console.log('[BackgroundParticles] 🎨 Rendering background particles (should only happen once)');
  
  return (
    <div style={{
      position: 'absolute',
      inset: 0,
      overflow: 'hidden',
      pointerEvents: 'none',
    }}>
      {particles.map(p => (
        <div
          key={`viewer-particle-${p.id}`}
          style={{
            position: 'absolute',
            left: `${p.x}%`,
            top: `${p.y}%`,
            width: `${2 + Math.random() * 3}px`,
            height: `${2 + Math.random() * 3}px`,
            background: 'rgba(255, 255, 255, 0.6)',
            borderRadius: '50%',
            animation: `floatParticle ${6 + Math.random() * 4}s ease-in-out infinite`,
            animationDelay: `${p.delay}s`,
            boxShadow: '0 0 10px rgba(255, 255, 255, 0.8)',
            willChange: 'transform, opacity',
          }}
        />
      ))}
      
      <style jsx>{`
        @keyframes floatParticle {
          0%, 100% { transform: translateY(0) translateX(0); opacity: 0.8; }
          50% { transform: translateY(-25px) translateX(12px); opacity: 1; }
        }
      `}</style>
    </div>
  );
});

export default BackgroundParticles;

